export default "__VITE_ASSET__DY8ygh2B__"